import React, { useState, useEffect } from 'react';

import './styles.css';

import { Dots } from "react-activity";

import { FaUsers } from 'react-icons/fa';
import accessServices from '../../../../../../services/accessServices';
import Popup from '../../../../../../components/Popup';
import SelectGroup from '../../../../../../components/SelectGroup';
import Notice from '../../../../../../components/Notice';

function PopupAccessLink(props) {
    const [selectList, setSelectList] = useState([]);
    const [hideList, setHideList] = useState([]);
    const [accesses, setAccesses] = useState(accessServices.accessTypes.map(obj => obj[1]));
    const [updating, setUpdating] = useState(false);

    useEffect(() => {
        let userAccesses = [];
        if (props.userAccesses) userAccesses = props.userAccesses.map(item => item.tipo);
        setHideList(accesses
            .map((access, idx) => userAccesses.includes(access) ? idx : -1)
            .filter(obj => obj !==-1));
    }, [props.userAccesses, accesses]);

    async function linkAccesses() {
        if (selectList.length) {
            const selectListNumbers = selectList.map(select => accessServices.accessTypes.find(obj => obj[1] === accesses[select])[0]);
            setUpdating(true);
            const response = await accessServices.giveAccess(props.userID, selectListNumbers);
            setUpdating(false);
            if (response.status === 200) {
                if (props.onLink) props.onLink(response.data);
                setSelectList([]);
                props.setVisibility(false);
            } else
                alert("Erro ao dar acessos ao usuário!");
        } else
            alert("Escolha um acesso para dar ao usuário.");
    };

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaUsers />}
            tittle='Acessos'
        >
            {
                accesses.length ?
                    <>
                        <SelectGroup
                            single={false}

                            hides={hideList}
                            markeds={selectList}
                            setMarkeds={setSelectList}
                        >
                            {
                                accesses.map((item, index) =>
                                    <div key={item.id} className='select-group-access-change'>
                                        <div className='select-group-access-change-tittle'>
                                            <p className='tittle'>{item}</p>
                                        </div>
                                    </div>
                                )
                            }
                        </SelectGroup>
                        <button
                            type='button'
                            onClick={() => updating ? alert("Um envio já está em andamento.") : linkAccesses()}
                        >
                            {
                                updating ?
                                    <Dots />
                                    : "Dar Acessos"
                            }
                        </button>
                    </>
                    : <Notice>Não há acessos disponíveis</Notice>
            }
        </Popup>
    )
}

export default PopupAccessLink;